import React, { useCallback, useEffect, useState, } from 'react';
import classNames from 'classnames';
import s from './SettingsPopover.scss';
import { useSettings } from '../../providers/SettingsProvider';
import { Main } from './Main/Main';
import { ViewProvider } from '../../providers/ViewProvider';
export const SettingsPopover = ({ isOpen }) => {
    const [visible, setVisible] = useState(isOpen);
    const { config: { fontFamily }, } = useSettings();
    const handleTransitionEnd = useCallback((event) => {
        if (!isOpen && event.propertyName === 'transform') {
            setVisible(false);
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen) {
            setVisible(true);
        }
    }, [isOpen]);
    if (!visible) {
        return null;
    }
    return (React.createElement(ViewProvider, null,
        React.createElement("div", { "data-hook": "wix-vod-playable-settings-popover", onTransitionEnd: handleTransitionEnd, className: classNames(s.wrapper, {
                [s.open]: isOpen,
            }), style: {
                fontFamily,
            } },
            React.createElement("div", { className: s.popover },
                React.createElement(Main, null)))));
};
export function createSettingsPopoverContainer() {
    const element = document.createElement('div');
    element.className = s.root;
    element.setAttribute('data-hook', 'wix-vod-playable-settings-popover-container');
    const updatePosition = (isInFullScreen) => {
        element.classList.toggle(s.fullScreen, isInFullScreen);
    };
    return {
        element,
        updatePosition,
    };
}
//# sourceMappingURL=SettingsPopover.js.map